import React, { useState, useRef } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import { sendQuotationRequest } from '../../api/quotationApi';

const QuoteForm = () => {

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone_number: '',
        message: ''
    });

    const [loading, setLoading] = useState(false);
    const [, forceUpdate] = useState();
    const validator = useRef(new SimpleReactValidator());

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validator.current.allValid()) {
            try {
                setLoading(true);

                await sendQuotationRequest(formData);

                alert("Quotation request sent successfully!");

                setFormData({
                    name: '',
                    email: '',
                    phone_number: '',
                    message: ''
                });

            } catch (error) {
                console.error(error);
                alert("Failed to send quotation request");
            } finally {
                setLoading(false);
            }
        } else {
            validator.current.showMessages();
            forceUpdate(1);
        }
    };

    return (
        <form id="quoteForm" onSubmit={handleSubmit}>
            <div className="row">

                <div className="item col-lg-12">
                    <label>Personal information</label>
                    <input
                        className="form-control"
                        type="text"
                        name="name"
                        placeholder="Your Name"
                        value={formData.name}
                        onChange={handleChange}
                    />
                    {validator.current.message('name', formData.name, 'required')}
                </div>

                <div className="item col-12">
                    <label>Email</label>
                    <input
                        className="form-control"
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                    />
                    {validator.current.message('email', formData.email, 'required|email')}
                </div>

                <div className="item col-12">
                    <label>Phone</label>
                    <input
                        className="form-control"
                        type="text"
                        name="phone_number"
                        placeholder="Phone"
                        value={formData.phone_number}
                        onChange={handleChange}
                    />
                    {validator.current.message('phone', formData.phone_number, 'required|numeric')}
                </div>

                <div className="item col-lg-12">
                    <label>Message</label>
                    <textarea
                        className="form-control"
                        name="message"
                        placeholder="Enter Your Message here"
                        value={formData.message}
                        onChange={handleChange}
                    />
                    {validator.current.message('message', formData.message, 'required')}
                </div>

                <div className="item col-12">
                    <input
                        className="theme-btn"
                        type="submit"
                        value={loading ? "Sending..." : "Get A Quote"}
                        disabled={loading}
                    />
                </div>

            </div>
        </form>
    );
};

export default QuoteForm;